import { render, staticRenderFns } from "./index.vue?vue&type=template&id=58ae28df&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\WebProject\\桌面\\JY-SSO\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('58ae28df')) {
      api.createRecord('58ae28df', component.options)
    } else {
      api.reload('58ae28df', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=58ae28df&", function () {
      api.rerender('58ae28df', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Branch/index.vue"
export default component.exports